import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiViewQuilt } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const DashboardsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.roles_names.includes("View Dashboards")) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="dashboards"
          onClick={() => handleClick("dashboards")}
          title={t("menu.dashboards.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiViewQuilt} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.dashboards.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon icon={openSubmenu.dashboards ? mdiChevronUp : mdiChevronDown} />
        </ListItemButton>
        <Collapse in={openSubmenu.dashboards} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {user.roles_names.includes("View RPA Dashboards") && (
              <HybridRouteListItemButtonLink
                caption="rpa dashboard"
                isReact={false}
                name="dashboards[rpaDashboard]"
                sx={{ pl: 4 }}
                title={t("menu.dashboards.submenu.rpaDashboard.title")}
                url="/dashboards"
              >
                <ListItemText
                  primary={t("menu.dashboards.submenu.rpaDashboard.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Dashboard - View Buyer Dashboards") && (
              <HybridRouteListItemButtonLink
                caption="buyer dashboard"
                isReact={false}
                name="dashboards[buyerDashboard]"
                sx={{ pl: 4 }}
                title={t("menu.dashboards.submenu.buyerDashboard.title")}
                url="/dashboards/buyer"
              >
                <ListItemText
                  primary={t("menu.dashboards.submenu.buyerDashboard.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes(
              "Dashboard - View Good Receipt Dashboards",
            ) && (
              <HybridRouteListItemButtonLink
                caption="goods receipt dashboard"
                isReact={false}
                name="dashboards[goodsReceiptDashboard]"
                sx={{ pl: 4 }}
                title={t("menu.dashboards.submenu.goodsReceiptDashboard.title")}
                url="/dashboards/good_receipt"
              >
                <ListItemText
                  primary={t(
                    "menu.dashboards.submenu.goodsReceiptDashboard.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes(
              "Dashboard - View Material Management Dashboards",
            ) && (
              <HybridRouteListItemButtonLink
                caption="material management dashboard"
                isReact={false}
                name="dashboards[materialManagementDashboard]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.dashboards.submenu.materialManagementDashboard.title",
                )}
                url="/dashboards/material_management"
              >
                <ListItemText
                  primary={t(
                    "menu.dashboards.submenu.materialManagementDashboard.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
